module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-30-e156b564b84c109b8d63bf2141a48de2.png";